import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectProfitData } from '../../../selectors/selectProfit';
import { IHowToEarnSchema } from '../../../repositories/price-estimator/entities/how_to_earn/HowToEarnSchema';
import { IProfitItemLayout } from '../../../components/ProfitItem';
import { trackButtonClick, trackDetailsClick } from '../utils/tracking';
import { useIsDesktop } from '@cian/valuation-utils-component';

export const useDailyRentProps = (): IProfitItemLayout | null => {
  const isDesktop = useIsDesktop();

  const [isDetailsShow, setIsDetailsShow] = React.useState(false);

  const profitData = useSelector(selectProfitData) as IHowToEarnSchema;
  const { dailyRent } = profitData;

  const detailsItems: IProfitItemLayout['detailsItems'] = [];

  if (dailyRent?.dailyIncome) {
    detailsItems.push({
      title: 'Средний доход за 1 ночь',
      value: dailyRent.dailyIncome,
    });
  }

  if (dailyRent?.averageOccupancy) {
    detailsItems.push({
      title: 'Средняя загруженность',
      value: dailyRent.averageOccupancy,
    });
  }

  if (dailyRent?.estimationPrice) {
    detailsItems.push({
      title: 'Оценка стоимости',
      value: dailyRent.estimationPrice,
    });
  }

  const handleClick = React.useCallback(() => {
    setIsDetailsShow(!isDetailsShow);
    trackDetailsClick('detailedDailyRent');
  }, [isDetailsShow, setIsDetailsShow]);

  const handleButtonClick = React.useCallback(() => {
    trackButtonClick('goDailyRent');
    window.open('https://www.cian.ru/new-offer/', '_blank');
  }, []);

  if (!dailyRent) {
    return null;
  }

  return {
    isDesktop,
    title: 'Сдать в посуточную аренду',
    description: 'Начните собственный бизнес по краткосрочной сдаче квартиры',
    wrapperDescription: 'Доход',
    income: dailyRent.income,
    percentForYear: dailyRent.percentForYear,
    details: dailyRent.details,
    detailsItems,
    additionalInfo: dailyRent.additionalInfo,
    showDetails: isDetailsShow,
    onClick: handleClick,
    buttonText: 'Сдать квартиру с Циан',
    onButtonClick: handleButtonClick,
  };
};
